import AddIcon from '@mui/icons-material/Add';
import { Button, CircularProgress, Container, CssBaseline, Grid } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Pagination from '@mui/material/Pagination';
import Typography from '@mui/material/Typography';
import { withStyles } from '@mui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Footer from '../../components/footer';
import HeaderMenu from '../../components/header-menu';
import CustomizedSnackbars from '../../components/material-snackbars';
import MyMaterialTable from '../../components/table';
import { Overlay } from '../../styles/global';
import { Styles } from '../../styles/material-styles';
import Api from 'src/services/api';
import { bindActionCreators } from 'redux';
import * as componentActions from '../../redux/actions/faqsubject';
import { AbilityContext } from '../../config/ability-context';
import FirstElement from 'src/components/first-element';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';

class FaqSubjectList extends Component {
    constructor(props) {
        super(props);
        this.emptyArray = null;
        this.state = {
            dataFilter: false,
            loading: false,
            openNotification: false,
            notificationVariant: 'error',
            notificationMessage: '',
            resultList: [],
            totalPages: 0,
            page: 1,
            pageStart: 0,
            pageEnd: 0,
            count: 0,
            searchValue: ''
        };
        this.callSearch = this.callSearch.bind(this);
        this.onFieldChange = this.onFieldChange.bind(this);
        this.closeNotification = this.closeNotification.bind(this);
        this.deleteItem = this.deleteItem.bind(this);
        this.clearFields = this.clearFields.bind(this);
    }
    onChangePaginate = (e, page) => {
        this.setState({ page: page });
        this.getItens(page);
    }
    setPagination(count, page) {
        let totalPage = Math.ceil(count / 10);
        this.setState({ totalPages: totalPage })
        if (count > 0) {
            if (page == 1) {
                if (count < 10) {
                    this.setState({ pageStart: 1, pageEnd: count });
                } else {
                    this.setState({ pageStart: 1, pageEnd: 10 });
                }
            } else {
                let pageStart = ((page - 1) * 10) + 1;
                if (count >= page * 10) {
                    this.setState({ pageStart: pageStart, pageEnd: page * 10 });
                } else {
                    this.setState({ pageStart: pageStart, pageEnd: count });
                }
            }
        } else {
            this.setState({ totalPages: 0, page: 1, count: 0 });
        }
    }
    onFieldChange(event) {
        this.setState({ [event.target.name]: event.target.value, page: 1 });
    }
    callSearch() {
        if (this.state.searchValue !== '') {
            this.getItens(this.state.page);
        }
    }
    async clearFields() {
        await this.setState({ searchValue: '', page: 1, loading: true })
        this.getItens(1);
    }
    deleteItem(data, resolve) {
        // Ajuste a rota da API conforme necessário
        Api.delete(`/faq-subject/${data.id}`)
            .then(result => {
                if (result.data.success) {
                    this.setState({
                        loading: false,
                        openNotification: true,
                        notificationVariant: 'success',
                        notificationMessage: 'Registro excluído com sucesso!',
                        resultList: []
                    });
                    this.getItens();
                } else {
                    this.setState({
                        loading: false, openNotification: true, notificationVariant: 'error',
                        notificationMessage: 'Erro ao excluir registro.'
                    });
                }
                resolve();
            })
            .catch(err => {
                resolve();
                this.setState({
                    loading: false, openNotification: true, notificationVariant: 'error',
                    notificationMessage: 'Erro ao excluir registro.'
                });
            });
    };
    componentDidMount() {
        this.getItens();
    }
    getItens(page = 1) {
        this.setState({ loading: true });
        let url = `/faq-subject/paginate?page=${page}`;
        if (this.state.searchValue !== '') {
            url += `&search=${this.state.searchValue}`
            this.setState({ dataFilter: true });
        }
        Api.get(url)
            .then(result => {
                if (result.data.success) {
                    if (result.data.data.length === 0) {
                        this.emptyArray = true
                    } else {
                        this.emptyArray = false
                    }
                    let count = result.data.count;
                    this.setState({ count: count });
                    this.setPagination(count, page);
                    const formattedList = result.data.data.map(item => ({ ...item }));
                    this.setState({ loading: false, resultList: formattedList });
                } else {
                    this.setState({
                        loading: false, openNotification: true, notificationVariant: 'error',
                        notificationMessage: 'Erro ao buscar registros.'
                    });
                }
            })
            .catch(() => {
                this.setState({
                    loading: false, openNotification: true, notificationVariant: 'error',
                    notificationMessage: 'Erro ao buscar registros.'
                });
            });
    };
    closeNotification() {
        this.setState({ openNotification: false });
    }
    render() {

        const { classes, headerMenu, actionsHeaderMenu } = this.props;
        const intl = this.props.intl;
        return (
            <div className={classes.root} style={{ paddingLeft: 0, marginLeft: 0 }}>
                <HeaderMenu />
                <main className={clsx(classes.content, {
                    [classes.contentShift]: headerMenu.open,
                }, classes.actionsContent, {
                    [classes.actionscontentShift]: actionsHeaderMenu.open,
                })}>
                    <div className={classes.drawerHeader} />
                    <Container component='main' maxWidth='xl' style={{ paddingLeft: 0, marginLeft: 0, maxWidth: '100%', }}>
                        {(!this.emptyArray || this.state.dataFilter) ? (
                            <div>
                                <CssBaseline />
                                <Grid container className={classes.mb20} spacing={0}>
                                    <Button
                                        variant='contained'
                                        color='secondary'
                                        size='large'
                                        className={classes.button}
                                        startIcon={<AddIcon />}
                                        component={Link} {...{ to: `/${this.props.match.params.lang}/faq-subject-registration` }}
                                    >
                                        Adicionar
                                    </Button>
                                </Grid>
                                <Grid container spacing={6} alignItems="center">
                                    <Grid item xs={12} sm={12}>
                                        <Card className="background-title-search">
                                            <CardContent>
                                                <Grid container spacing={1} alignItems="center">
                                                    <Grid item xs={12} sm={5} md={3} lg={6}>
                                                        <Typography variant="h5">
                                                            Assunto do Faq
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                </Grid>
                                <MyMaterialTable
                                    title=""
                                    rowClick={(event, rowData) => {
                                        this.props.addCurrent(rowData);
                                        this.props.history.push(`/${this.props.match.params.lang}/faq-subject-edit`);
                                        
                                    }}
                                    columns={[
                                        { title: 'ID', field: 'id' },
                                        { title: 'Nome', field: 'name' },
                                        { title: 'Descrição', field: 'description', render: rowData => {
                                            const maxLength = 120;
                                            let text = rowData.description || '';
                                            // Remove tags para o limite, mas mantém o HTML se for menor
                                            const plainText = text.replace(/<[^>]+>/g, '');
                                            if (plainText.length > maxLength) {
                                                // Limita o texto plano e adiciona reticências
                                                const limited = plainText.substring(0, maxLength) + '...';
                                                return <span title={plainText}>{limited}</span>;
                                            }
                                            return <span dangerouslySetInnerHTML={{ __html: text }} />;
                                        } }
                                    ]}
                                    data={this.state.resultList}
                                    deleteItem={this.deleteItem}
                                />
                                <Grid container style={{ marginBottom: 12, marginTop: 8 }}>
                                    <Grid item xs={12} md={3}>
                                        <Pagination count={this.state.totalPages} page={this.state.page} onChange={this.onChangePaginate} />
                                    </Grid>
                                    <Grid item xs={12} sm={3} style={{ marginTop: 6 }}>
                                        {this.state.pageStart} a {this.state.pageEnd} de {this.state.count} registros
                                    </Grid>
                                </Grid>
                            </div>
                        ) : (
                            <div>
                                <FirstElement
                                    title={intl.formatMessage({ id: "create.your.new.faq.subject.section" })}
                                    subtitle={intl.formatMessage({ id: "you.can.create.your.faq.subject.sections.here" })}
                                    //buttonText = "Novo Chamado"
                                    buttonText=
                                    {
                                        <Button
                                            variant='contained'
                                            color='secondary'
                                            size='large'
                                            className={classes.button}
                                            startIcon={<AddIcon />}
                                            component={Link} {...{ to: `/${this.props.match.params.lang}/faq-subject-registration` }}
                                        >
                                            {<FormattedMessage id="add" />}
                                        </Button>
                                    }

                                    icon={<AccountBalanceWalletIcon style={{ fontSize: "45px" }} />}

                                />
                            </div>
                        )}
                        {this.state.loading && (
                            <Overlay>
                                <CircularProgress color='secondary' />
                            </Overlay>
                        )}
                        <CustomizedSnackbars
                            variant={this.state.notificationVariant}
                            message={this.state.notificationMessage}
                            isOpen={this.state.openNotification}
                            toClose={this.closeNotification}
                        />
                    </Container>
                </main>
                <Footer />
            </div>
        );
    }
}

FaqSubjectList.propTypes = {
    classes: PropTypes.object.isRequired
};
const mapStateToProps = state => ({
    actionsHeaderMenu: state.actionsHeaderMenu,
    headerMenu: state.headerMenu,
    userSession: state.userSession,
});
const mapDispatchToProps = dispatch =>
    bindActionCreators(componentActions, dispatch);
export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(FaqSubjectList)));

FaqSubjectList.contextType = AbilityContext;
